export default __webpack_public_path__ + "static/media/web.a045574b.config";